module.exports = __webpack_public_path__ + "img/firm2026.50648d7e.png";